import {AttachmentType} from './attachment-type';

export class CarouselData {
    id: any;
    src: any;
    file: File;
    fileType: AttachmentType;
    owner: string;
    base64: any;
    addTimeStamp: boolean = false;
}
